import { Box, Typography, alpha, useTheme } from '@mui/material'
import React from 'react'

const AccentBarPanel = ({ title, text, children }: { title?: string; text?: string; children?: React.ReactNode }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <Box
      sx={{
        background: isDark ? 'linear-gradient(135deg, #2a4d73, #336699)' : 'linear-gradient(135deg, #3a7bd5, #4a90d9)',
        borderRadius: 3,
        p: 3,
        mt: 2,
        textAlign: 'left',
        position: 'relative',
        overflow: 'hidden',
        borderTop: `3px solid ${theme.palette.text.highlight}`,
      }}
    >
      {title && (
        <Typography
          variant="overline"
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.08em',
            color: theme.palette.text.highlight,
            mb: 1,
            display: 'block',
          }}
        >
          {title}
        </Typography>
      )}
      {text && (
        <Typography
          sx={{
            fontSize: '1.2rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: alpha(theme.palette.text.primary, 0.92),
          }}
        >
          {text}
        </Typography>
      )}
      {children ?? null}
    </Box>
  )
}

export default AccentBarPanel
